import { Modal } from 'UIPackage/ModalModule/components/Modal';

import { ModalBody } from '../../../UIPackage/ModalModule/components/ModalBody';
import styles from './ErknmLinkOtherWarningModal.module.scss';

interface IErknmLinkOtherWarningModalProps {
  visible?: boolean;
  onClose: () => void;
}

export const ErknmLinkOtherWarningModal = ({ visible, onClose }: IErknmLinkOtherWarningModalProps) => {
  return (
    <Modal visible={visible} onClose={onClose} modalBodyClassName={styles.ModalBody}>
      <ModalBody size="content">
        <div>
          <div className={styles.Title}>Уважаемый пользователь!</div>
          <p>
            Обратите внимание, в паспорт повторной проверки добавлен объект контроля, не отнесенный к категории риска
            посредством ЕРВК, что может препятствовать согласованию проверки.
          </p>
          <p>
            Для актуализации сведений об объекте контроля (категории риска) воспользуйтесь кнопкой «Перезапросить» в
            разделе «Сведения об объектах контроля»
          </p>
        </div>
      </ModalBody>
    </Modal>
  );
};
